import React from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from "recharts";
import useGradeLevelHook from "../hooks/GradeLevelHook";

// Define a fixed color for each grade level
const gradeLevelColors = {
  _7: "#FFB6C1", // Light Pink
  _8: "#87CEEB", // Sky Blue
  _9: "#32CD32", // Lime Green
  _10: "#6495ED", // Cornflower Blue
  _11: "#00008B", // Dark Blue
  _12: "#DAA520", // Golden Rod
};

const GradeLevel = ({ schoolId }) => {
  const { data, loading, error } = useGradeLevelHook(schoolId);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading data</div>;
  }

  // Log the data to ensure it's being fetched correctly
  console.log("Data:", data);

  // Define the grade levels
  const gradeLevels = ["_7", "_8", "_9", "_10", "_11", "_12"];

  // Format the data to add a % sign
  const formattedData = data.map((item) => {
    const formattedItem = { ...item };
    gradeLevels.forEach((level) => {
      if (formattedItem[level] !== undefined) {
        formattedItem[level] = `${formattedItem[level]}%`;
      }
    });
    return formattedItem;
  });

  return (
    <Card>
      <CardHeader
        title="Grade Level"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="Year" />
            <YAxis />
            <Tooltip formatter={(value) => `${value}%`} />
            <Legend />
            {gradeLevels.map((level) => (
              <Bar key={level} dataKey={level} fill={gradeLevelColors[level]}>
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}-${level}`}
                    fill={gradeLevelColors[level]}
                  />
                ))}
              </Bar>
            ))}
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default GradeLevel;
